<template lang="pug">
  section
    el-row
      el-col(:span="24")
        h4.card-title Resultado da pesquisa
        div(class="card-body")
          el-table(
            :data="dados"
            style="cursor: pointer"
          )
            el-table-column(
              label='Ordem de Serviço',
              min-width="250",
              prop="numeroOS"
            )
            el-table-column(
              label='Processos pendentes',
              min-width="100",
              prop="totalProcessosPendentes"
              align="center"
            )
            el-table-column(
              label='Processos tramitados',
              min-width="100",
              prop="totalProcessosTramitados"
              align="center"
            )
            el-table-column(
              label='Total',
              min-width="100",
              prop="totalProcessos"
              align="center"
            )
</template>

<script>

export default {
  props: {
    dados: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/_variables.scss';

 .card-title {
   margin-left: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/os/TabelaOS.vue